import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import "./assets/style.css";
import NavBarPage from "./pages/NavbarPage";
import MappingWindow from "./pages/MappingWindow";
import Subscription from "./pages/Subscription";
import Confirmation from "./pages/Confirmation";
import ErrorModal from "./components/modals/ErrorModal";
import SuccessModal from "./components/modals/SuccessModal";
import SaveModal from "./components/modals/SaveModal";
import SearchWindow from "./pages/SearchWindow";
import SetupGuide from "./pages/SetupGuide";
import IframeWindow from "./pages/IframeWindow";
import CmsNotifications from "./helpers/CmsNotifications";
import { CmsProvider } from "./helpers/cmsHook";
import BulkUpdate from "./pages/BulkUpdate";
import { DirtyProvider } from "./context/dirty";
function App() {
  return (
    <DirtyProvider>
      <CmsProvider>
        <Router>
          <SuccessModal />
          <ErrorModal />
          <SaveModal />
          <Routes>
            <Route path="/setup" element={<NavBarPage />} />
            <Route path="/mappingwindow" element={<MappingWindow />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/searchwindow" element={<SearchWindow />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="/setupguide" element={<SetupGuide />} />
            <Route path="/bulkupdate" element={<BulkUpdate />}></Route>
            <Route path="/iframewindow" element={<IframeWindow />} />
            <Route path="/edit-notifications" element={<CmsNotifications />} />
          </Routes>
        </Router>
      </CmsProvider>
    </DirtyProvider>
  );
}

export default App;
